import { axiosApi } from "./helper";

export function getImage(path) {
  return axiosApi("ressource/media" + path);
}

export function getVideo(path) {
  return axiosApi("ressource/video" + path);
}
